import { AxiosHttpClient } from '@/javascript/infra/http'

export const makeAxiosHttpClient = (): AxiosHttpClient => new AxiosHttpClient()